import * as React from 'react';
import { observer } from "mobx-react";
import { Form, Select, Popover, Button, Tooltip } from 'antd';

import { ObjectUtils } from 'src/core/utils/object';

const FormItem = Form.Item;
const { Option, OptGroup } = Select;

interface Props {
	label?: string;
	model: VisibilityItem;
	disabled?: boolean;
	required?: boolean;
	onGetErrorMessage?: () => Promise<ValidationError[]>;
}

interface State {
	errors: ValidationError[];
	values?: string[];
}

@observer
export class VisibilityEditorView extends React.Component<Props, State> {
	private getValues = (model: VisibilityItem): string[] => {
		const values: string[] = [];
		if (model == null) {
			model = { client: [], agent: [], supplier: [] };
		}
		for (const value of model.client) {
			values.push('client-' + value);
		}
		for (const value of model.agent) {
			values.push('agent-' + value);
		}
		for (const value of model.supplier) {
			values.push('supplier-' + value);
		}
		return values;
	}

	public state: State = {
		errors: [],
		values: this.getValues(this.props.model),
	}

	public componentWillReceiveProps(nextProps: Readonly<Props>): void {
		if (!ObjectUtils.equals(this.props.model, nextProps.model)) {
			let values = this.getValues(nextProps.model);
			this.setState({
				errors: [],
				values: values
			});
		}
	}

	public render() {
		let { label, required } = this.props;
		const { errors, values } = this.state;

		if (label === undefined) {
			label = 'Visibility';
		}
		const hasErrors = errors.length !== 0 || (required && this.isEmpty());
		const visibilities = values || [];

		return (
			<FormItem
				label={label}
				required={required}
				validateStatus={hasErrors ? 'error' : 'success'}
			>
				<Popover
					content={this.renderSelection()}
					trigger="click"
					title={label}
					overlayStyle={{ minWidth: 200, maxWidth: 400 }}
				>
					<Tooltip
						placement="bottom"
						title={visibilities.map(e => e.substr(0, 1).toUpperCase() + e.substr(1)).join(", ")}
				>
						<Button
							shape="circle"
							icon="eye"
							type={visibilities.length > 0 ? "primary" : "ghost"}
						/>
					</Tooltip>
				</Popover>
			</FormItem>
		);
	}

	private renderSelection(): React.ReactNode {
		const { disabled } = this.props;

		return (
			<Select
				mode="multiple"
				style={{ width: '100%' }}
				value={this.state.values}
				disabled={disabled}
				onChange={this.onChange}
				optionLabelProp="title"
				placeholder="Select items"
			>
				<OptGroup label="Client" >
					<Option value="client-General" title="Client-General">
						<span style={{ fontSize: '12px' }}>General</span>
					</Option>
					<Option value="client-Invoice" title="Client-Invoice">
						<span style={{ fontSize: '12px' }}>Invoice</span>
					</Option>
					<Option value="client-Offer" title="Client-Offer">
						<span style={{ fontSize: '12px' }}>Offer</span>
					</Option>
					<Option value="client-Voucher" title="Client-Voucher">
						<span style={{ fontSize: '12px' }}>Voucher</span>
					</Option>
				</OptGroup>
				<OptGroup label="Agent">
					<Option value="agent-General" title="Agent-General">
						<span style={{ fontSize: '12px' }}>General</span>
					</Option>
					<Option value="agent-Invoice" title="Agent-Invoice">
						<span style={{ fontSize: '12px' }}>Invoice</span>
					</Option>
					<Option value="agent-Offer" title="Agent-Offer">
						<span style={{ fontSize: '12px' }}>Offer</span>
					</Option>
					<Option value="agent-Voucher" title="Agent-Voucher">
						<span style={{ fontSize: '12px' }}>Voucher</span>
					</Option>
				</OptGroup>
				<OptGroup label="Supplier">
					<Option value="supplier-General" title="Supplier-General">
						<span style={{ fontSize: '12px' }}>General</span>
					</Option>
					<Option value="supplier-Invoice" title="Supplier-Invoice">
						<span style={{ fontSize: '12px' }}>Invoice</span>
					</Option>
					<Option value="supplier-Offer" title="Supplier-Offer">
						<span style={{ fontSize: '12px' }}>Offer</span>
					</Option>
					<Option value="supplier-Voucher" title="Supplier-Voucher">
						<span style={{ fontSize: '12px' }}>Voucher</span>
					</Option>
				</OptGroup>
			</Select>
		);
	}

	private isEmpty = (): boolean => {
		const values = this.state.values;

		if (values == null) { return true; }
		return values.length === 0;
	}

	private onChange = (selection: string[]): void => {
		const model = this.props.model;

		// limpiar siempre el arreglo de cliente, agente
		model.client = selection.map(e => e.split("-"))
			.filter(e => e[0] === "client")
			.reduce((prev, curr) => ([...prev, ...curr.filter(e => e !== "client")]), []);
		model.agent = selection.map(e => e.split("-"))
			.filter(e => e[0] === "agent")
			.reduce((prev, curr) => ([...prev, ...curr.filter(e => e !== "agent")]), []);
		model.supplier = selection.map(e => e.split("-"))
			.filter(e => e[0] === "supplier")
			.reduce((prev, curr) => ([...prev, ...curr.filter(e => e !== "supplier")]), []);
		this.setState({ values: selection });
	}
}



// WEBPACK FOOTER //
// ./src/app/shared/parts/visibility-editor.view.tsx